var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 15.495C20.4961 15.495 21 15.9989 21 16.62V19.995C21 22.4803 18.9853 24.495 16.5 24.495H4.5C2.01469 24.495 0 22.4803 0 19.995V16.62C0 15.9965 0.503438 15.495 1.125 15.495C1.74609 15.495 2.25 15.9989 2.25 16.62V19.995C2.25 21.2325 3.2625 22.245 4.5 22.245H16.5C17.7375 22.245 18.75 21.2325 18.75 19.995V16.62C18.75 15.9965 19.2516 15.495 19.875 15.495ZM9.73125 0.801497L3.35625 6.75931C2.90062 7.22623 2.88 7.93873 3.30609 8.38873C3.73088 8.84136 4.44281 8.86311 4.89563 8.43706L9.375 4.22436V15.8681C9.375 16.4934 9.88125 16.995 10.5 16.995C11.1187 16.995 11.625 16.4911 11.625 15.9122V4.22436L16.1044 8.43936C16.557 8.86564 17.2687 8.84365 17.6939 8.39103C17.8969 8.17311 18 7.89654 18 7.61998C18 7.32115 17.8814 7.02233 17.6455 6.80108L11.2705 0.843263C10.8375 0.392794 10.1625 0.392794 9.73125 0.801497Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowIcon);
export default __webpack_public_path__ + "static/media/UploadArrowIcon.10902a54031e4309eee755e7add461b5.svg";
export { ForwardRef as ReactComponent };